import { PageData } from '../models';

const checkoutAddressesAlias = 'checkout-addresses';

export const PAGE_ALIASES_MAP: { [url: string]: PageData } = {
  '/': {
    alias: 'home',
    anonymous: true,
  },
  '/account/info': {
    alias: 'account-info',
  },
  '/account/info/edit-business-info': {
    alias: 'edit-business-info',
  },
  '/account/info/add-business-info': {
    alias: 'add-business-info',
  },
  '/account/info/edit-private-info': {
    alias: 'edit-private-info',
  },
  '/account/info/change-password': {
    alias: 'change-password',
  },
  '/account/info/change-email': {
    alias: 'change-email',
  },
  '/account/address-book': {
    alias: 'address-book',
  },
  '/account/address-book/create-address': {
    alias: 'create-address',
  },
  '/account/address-book/edit-address': {
    alias: 'edit-address',
  },
  '/account/orders-history': {
    alias: 'orders-history',
  },
  '/auth/login': {
    alias: 'login',
    anonymous: true,
  },
  '/auth/password-restoration': {
    alias: 'password-restoration',
    anonymous: true,
  },
  '/auth/email-validation': {
    alias: 'email-validation',
    anonymous: true,
  },
  '/auth/secure-login-notice': {
    alias: 'secure-login-notice',
    anonymous: true,
  },
  '/auth/after-password-restoration': {
    alias: 'after-password-restoration',
    anonymous: true,
  },
  '/auth/after-email-validation': {
    alias: 'after-email-validation',
    anonymous: true,
  },
  '/auth/registration': {
    alias: 'registration',
    anonymous: true,
  },
  '/auth/registration/metro-card': {
    alias: 'metro-card-registration',
    anonymous: true,
  },
  '/auth/registration/registration-type-private-or-business': {
    alias: 'registration-type-private-or-business',
    anonymous: false,
  },
  '/auth/validate-email': {
    alias: 'validate-email',
    anonymous: true,
  },
  '/auth/login-flow-type': {
    alias: 'login-flow-type',
    anonymous: true,
  },
  '/auth/registration/business': {
    alias: 'business-registration',
    anonymous: true,
  },
  '/auth/registration/consumer': {
    alias: 'consumer-registration',
    anonymous: true,
  },
  '/auth/register': {
    alias: 'idam-register',
    anonymous: true,
  },
  '/auth/passwordless-signup': {
    alias: 'passwordless-signup',
    anonymous: false,
  },
  '/auth/registration/registration-type': {
    alias: 'registration-type',
    anonymous: false,
  },
  '/auth/registration/add-business-details': {
    alias: 'add-business-details',
    anonymous: false,
  },
  '/auth/registration/passwordless-business-details': {
    alias: 'passwordless-business-details',
    anonymous: false,
  },
  '/auth/registration/check-vat': {
    alias: 'check-vat',
    anonymous: false,
  },
  '/auth/registration/check-tax-id': {
    alias: 'check-tax-id',
    anonymous: false,
  },
  '/auth/registration/branch-selection': {
    alias: 'branch-selection',
    anonymous: false,
  },
  '/auth/reset-password': {
    alias: 'reset-password',
    anonymous: true,
  },
  '/auth/login-redirect': {
    alias: 'login-redirect',
    anonymous: true,
  },
  '/auth/customers-list': {
    alias: 'customers-list',
    anonymous: true,
  },
  '/logout': {
    alias: 'logout',
  },
  '/catalog': {
    alias: 'catalog',
    anonymous: true,
  },
  '/product': {
    alias: 'product',
    anonymous: true,
  },
  '/seller': {
    alias: 'seller',
    anonymous: true,
  },
  '/legal/about': {
    alias: 'legal',
    anonymous: true,
  },
  '/legal/imprint': {
    alias: 'legal',
    anonymous: true,
  },
  '/legal/general-terms-and-conditions': {
    alias: 'legal',
    anonymous: true,
  },
  '/legal/privacy-policy': {
    alias: 'legal',
    anonymous: true,
  },
  '/legal/disposal-and-environmental-regulations': {
    alias: 'legal',
    anonymous: true,
  },
  '/checkout/cart': {
    alias: 'cart',
    anonymous: true,
  },
  '/checkout/checkout/': {
    alias: 'checkout',
  },
  '/checkout/checkout/order': {
    alias: 'checkout-order',
  },
  '/checkout/checkout/addresses/shipping': {
    alias: checkoutAddressesAlias,
  },
  '/checkout/checkout/addresses/shipping/create': {
    alias: checkoutAddressesAlias,
  },
  '/checkout/checkout/addresses/shipping/edit/': {
    alias: checkoutAddressesAlias,
  },
  '/checkout/checkout/addresses/billing': {
    alias: checkoutAddressesAlias,
  },
  '/checkout/checkout/addresses/billing/create': {
    alias: checkoutAddressesAlias,
  },
  '/checkout/checkout/addresses/billing/edit': {
    alias: checkoutAddressesAlias,
  },
  '/server-error': {
    alias: 'server-error',
    anonymous: true,
  },
  '/not-found': {
    alias: 'not-found',
    anonymous: true,
  },
};
